module.exports = __webpack_public_path__ + "static/img/quxiao.933a9013.png";